import { requestJson } from "../../lib/api";
import type {
  BusinessSalesWorkspacePayload,
  SalesDiscoveryCallInput,
  SalesFollowUpInput,
  SalesLeadInput,
  SalesOpportunityInput,
  BusinessLeadRecord,
  BusinessOpportunityRecord,
  BusinessDiscoveryCallRecord,
  BusinessFollowUpRecord,
  BusinessLeadActivityRecord,
  BusinessLeadSourceRecord,
  BusinessLeadStatusHistoryRecord,
  BusinessLeadTagRecord,
} from "./TruevanceSalesCenterData";

export async function loadTruevanceSalesWorkspace() {
  return requestJson<BusinessSalesWorkspacePayload>("/api/admin/truevance-sales");
}

export async function createTruevanceLeadSource(payload: {
  sourceName: string;
  sourceGroup?: string;
  description?: string;
  companyId?: string;
  workspaceId?: string;
  sortOrder?: number;
}) {
  return requestJson<{ leadSource: BusinessLeadSourceRecord }>("/api/admin/truevance-sales/lead-sources", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateTruevanceLeadSource(sourceId: string, payload: Partial<{
  sourceName: string;
  sourceGroup: string;
  description: string;
  sortOrder: number;
  isActive: boolean;
}>) {
  return requestJson<{ leadSource: BusinessLeadSourceRecord }>(`/api/admin/truevance-sales/lead-sources/${sourceId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function archiveTruevanceLeadSource(sourceId: string) {
  return requestJson<{ leadSource: BusinessLeadSourceRecord }>(`/api/admin/truevance-sales/lead-sources/${sourceId}`, {
    method: "DELETE",
  });
}

export async function createTruevanceLeadTag(payload: {
  tagName: string;
  tagColor?: string;
  description?: string;
  companyId?: string;
  workspaceId?: string;
  sortOrder?: number;
}) {
  return requestJson<{ leadTag: BusinessLeadTagRecord }>("/api/admin/truevance-sales/lead-tags", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateTruevanceLeadTag(tagId: string, payload: Partial<{
  tagName: string;
  tagColor: string;
  description: string;
  sortOrder: number;
  isActive: boolean;
}>) {
  return requestJson<{ leadTag: BusinessLeadTagRecord }>(`/api/admin/truevance-sales/lead-tags/${tagId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function archiveTruevanceLeadTag(tagId: string) {
  return requestJson<{ leadTag: BusinessLeadTagRecord }>(`/api/admin/truevance-sales/lead-tags/${tagId}`, {
    method: "DELETE",
  });
}

export async function createTruevanceSalesLead(payload: SalesLeadInput) {
  return requestJson<{ lead: BusinessLeadRecord }>("/api/admin/truevance-sales/leads", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateTruevanceSalesLead(leadId: string, payload: Partial<SalesLeadInput>) {
  return requestJson<{ lead: BusinessLeadRecord }>(`/api/admin/truevance-sales/leads/${leadId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function archiveTruevanceSalesLead(leadId: string) {
  return requestJson<{ lead: BusinessLeadRecord }>(`/api/admin/truevance-sales/leads/${leadId}`, {
    method: "DELETE",
  });
}

export async function setTruevanceLeadTags(leadId: string, tagIds: string[]) {
  return requestJson<{ lead: BusinessLeadRecord }>(`/api/admin/truevance-sales/leads/${leadId}/tags`, {
    method: "PATCH",
    body: JSON.stringify({ tagIds }),
  });
}

export async function createTruevanceDiscoveryCall(payload: SalesDiscoveryCallInput) {
  return requestJson<{ discoveryCall: BusinessDiscoveryCallRecord }>("/api/admin/truevance-sales/discovery-calls", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateTruevanceDiscoveryCall(discoveryCallId: string, payload: Partial<SalesDiscoveryCallInput>) {
  return requestJson<{ discoveryCall: BusinessDiscoveryCallRecord }>(`/api/admin/truevance-sales/discovery-calls/${discoveryCallId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function archiveTruevanceDiscoveryCall(discoveryCallId: string) {
  return requestJson<{ discoveryCall: BusinessDiscoveryCallRecord }>(`/api/admin/truevance-sales/discovery-calls/${discoveryCallId}`, {
    method: "DELETE",
  });
}

export async function createTruevanceSalesOpportunity(payload: SalesOpportunityInput) {
  return requestJson<{ opportunity: BusinessOpportunityRecord }>("/api/admin/truevance-sales/opportunities", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateTruevanceSalesOpportunity(opportunityId: string, payload: Partial<SalesOpportunityInput>) {
  return requestJson<{ opportunity: BusinessOpportunityRecord }>(`/api/admin/truevance-sales/opportunities/${opportunityId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function archiveTruevanceSalesOpportunity(opportunityId: string) {
  return requestJson<{ opportunity: BusinessOpportunityRecord }>(`/api/admin/truevance-sales/opportunities/${opportunityId}`, {
    method: "DELETE",
  });
}

export async function createTruevanceSalesFollowUp(payload: SalesFollowUpInput) {
  return requestJson<{ followUp: BusinessFollowUpRecord }>("/api/admin/truevance-sales/follow-ups", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateTruevanceSalesFollowUp(followUpId: string, payload: Partial<SalesFollowUpInput>) {
  return requestJson<{ followUp: BusinessFollowUpRecord }>(`/api/admin/truevance-sales/follow-ups/${followUpId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function archiveTruevanceSalesFollowUp(followUpId: string) {
  return requestJson<{ followUp: BusinessFollowUpRecord }>(`/api/admin/truevance-sales/follow-ups/${followUpId}`, {
    method: "DELETE",
  });
}
